import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import axios from "axios";
// axios.defaults.baseURL = 'https://asia-east2-portfolio-717c7.cloudfunctions.net/server';
axios.defaults.baseURL = "http://localhost:5001/portfolio-717c7/asia-east2/server";

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();
